(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mijota-landing-7-raisons"] && !Shopify.designMode) return;
  try {
    
  if ('customElements' in window && !customElements.get('mijota-landing-seven')) {
    class MijotaLandingSeven extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abortController = new AbortController();
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.videos = Array.from(this.querySelectorAll('.mijota-l7__video'));
        this.ratios = new Map(this.videos.map((video) => [video, 0]));
        this.setupVideos();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.videoObserver?.disconnect();
      }

      setupVideos() {
        const signal = this.abortController.signal;

        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => this.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
            this.updateAutoplay();
          }, { threshold: [0, 0.35, 0.58, 0.75, 1] });
          this.videos.forEach((video) => this.videoObserver.observe(video));
        }

        this.motionQuery.addEventListener?.('change', () => this.updateAutoplay(), { signal });
        if (this.motionQuery.matches) this.videos.forEach((video) => this.pause(video));
      }

      pause(video) {
        video.pause();
      }

      playOnly(video) {
        this.videos.forEach((candidate) => {
          if (candidate !== video) this.pause(candidate);
        });
        if (video.paused) video.play().catch(() => {});
      }

      updateAutoplay() {
        if (this.motionQuery.matches) {
          this.videos.forEach((video) => {
            this.pause(video);
            if (video.currentTime > 0) video.load();
          });
          return;
        }
        let bestVideo = null;
        let bestRatio = 0;
        this.ratios.forEach((ratio, video) => {
          if (ratio >= 0.58 && ratio > bestRatio) {
            bestVideo = video;
            bestRatio = ratio;
          }
        });
        if (bestVideo) this.playOnly(bestVideo);
        else this.videos.forEach((video) => this.pause(video));
      }

    }

    customElements.define('mijota-landing-seven', MijotaLandingSeven);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mijota-product-hero"]) return;
  try {
    
  (function() {
    document.querySelectorAll('.mijota-pdp').forEach(function(root) {
      var slides = root.querySelectorAll('[data-slide-index]');
      var thumbs = root.querySelectorAll('[data-thumb-index]');
      var navs = root.querySelectorAll('[data-nav]');
      var qtyInput = root.querySelector('.mijota-pdp__qty-input');
      var qtyBtns = root.querySelectorAll('[data-qty]');
      var current = 0;
      var total = slides.length;

      function activate(i) {
        if (i < 0) i = total - 1;
        if (i >= total) i = 0;
        current = i;
        slides.forEach(function(s) {
          var idx = parseInt(s.getAttribute('data-slide-index'), 10);
          s.classList.toggle('is-active', idx === current);
          s.setAttribute('aria-current', idx === current ? 'true' : 'false');
        });
        thumbs.forEach(function(t) {
          var idx = parseInt(t.getAttribute('data-thumb-index'), 10);
          t.classList.toggle('is-active', idx === current);
        });
      }

      thumbs.forEach(function(t) {
        t.addEventListener('click', function() {
          activate(parseInt(t.getAttribute('data-thumb-index'), 10));
        });
      });

      navs.forEach(function(n) {
        n.addEventListener('click', function() {
          var dir = n.getAttribute('data-nav');
          activate(dir === 'next' ? current + 1 : current - 1);
        });
      });

      qtyBtns.forEach(function(b) {
        b.addEventListener('click', function() {
          if (!qtyInput) return;
          var v = parseInt(qtyInput.value, 10) || 1;
          var dir = b.getAttribute('data-qty');
          var n = dir === 'increment' ? v + 1 : v - 1;
          if (n < 1) n = 1;
          if (n > 99) n = 99;
          qtyInput.value = n;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mijota-promo-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initPromoTimers() {
      document.querySelectorAll('.mijota-promo').forEach(function(root) {
      if (root.dataset.timerReady === 'true') return;
      root.dataset.timerReady = 'true';
      var mode = root.getAttribute('data-timer-mode') || 'daily_midnight';
      var sectionId = root.getAttribute('data-section-id') || 'default';
      var endTs;

      function getNextLocalMidnightTs() {
        var nextMidnight = new Date();
        nextMidnight.setHours(24, 0, 0, 0);
        return nextMidnight.getTime();
      }

      if (mode === 'fixed_date') {
        var endStr = root.getAttribute('data-end-date');
        endTs = new Date(endStr).getTime();
        if (isNaN(endTs)) return;
      } else if (mode === 'daily_midnight') {
        endTs = getNextLocalMidnightTs();
        root.classList.remove('mijota-promo--ended');
      } else {
        // per_session : 7h par session navigateur (sessionStorage),
        // remis à zéro à la fermeture de l'onglet/navigateur
        var hours = parseFloat(root.getAttribute('data-session-hours')) || 7;
        var storageKey = 'mijota_promo_end_' + sectionId;
        var stored = null;
        try { stored = sessionStorage.getItem(storageKey); } catch (e) {}
        if (stored && !isNaN(parseInt(stored, 10)) && parseInt(stored, 10) > Date.now()) {
          endTs = parseInt(stored, 10);
        } else {
          endTs = Date.now() + (hours * 3600000);
          try { sessionStorage.setItem(storageKey, String(endTs)); } catch (e) {}
        }
      }

      var elDays = root.querySelector('[data-unit="days"]');
      var elHours = root.querySelector('[data-unit="hours"]');
      var elMinutes = root.querySelector('[data-unit="minutes"]');
      var elSeconds = root.querySelector('[data-unit="seconds"]');

      // En modes per_session et daily_midnight, on cache le bloc "jours".
      if ((mode === 'per_session' || mode === 'daily_midnight') && elDays && elDays.parentElement) {
        var daysBlock = elDays.parentElement;
        daysBlock.style.display = 'none';
        var sep = daysBlock.nextElementSibling;
        if (sep && sep.classList && sep.classList.contains('mijota-promo__timer-sep')) {
          sep.style.display = 'none';
        }
      }

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        var diff = endTs - Date.now();
        if (mode === 'daily_midnight' && diff <= 0) {
          endTs = getNextLocalMidnightTs();
          diff = endTs - Date.now();
        } else if (diff <= 0) {
          root.classList.add('mijota-promo--ended');
          if (elDays) elDays.textContent = '00';
          if (elHours) elHours.textContent = '00';
          if (elMinutes) elMinutes.textContent = '00';
          if (elSeconds) elSeconds.textContent = '00';
          if (intervalId) clearInterval(intervalId);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = mode === 'daily_midnight'
          ? Math.floor(diff / 3600000)
          : Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (elDays) elDays.textContent = pad(d);
        if (elHours) elHours.textContent = pad(h);
        if (elMinutes) elMinutes.textContent = pad(m);
        if (elSeconds) elSeconds.textContent = pad(s);
      }

      tick();
      var intervalId = setInterval(tick, 1000);

      if (mode === 'daily_midnight') {
        document.addEventListener('visibilitychange', function() {
          if (document.visibilityState !== 'visible') return;
          endTs = getNextLocalMidnightTs();
          tick();
        });
      }
    });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPromoTimers, { once: true });
    } else {
      initPromoTimers();
    }
    document.addEventListener('shopify:section:load', initPromoTimers);
  })();

  } catch(e) { console.error(e); }
})();
})();
